module.exports = __webpack_public_path__ + "static/img/CO-GP.5a69ddb6.png";